import React from "react";
import AllMyTeamsPage from "../../components/MyTeamPage/AllMyTeamsPage";

const LoginPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <AllMyTeamsPage />
    </div>
  );
};

export default LoginPage;